import { SessionCropTaskBarProps } from "@/app/activity/detail/sessionCropTaskBar/type.ts"
import BasicButton from "@/components/button/BasicButton.tsx"
import { useTranslation } from "react-i18next"
import Icon from "@/components/icon/Icon.tsx"

import "./sessionCropTaskBar.scss"
import SplitButton from "@/components/button/SplitButton.tsx"
import { CropOption } from "@/app/activity/detail/type.ts"

export default function SessionCropTaskBar({
  isSelectingCopyItem,
  onClickCrop,
  onClickCancel,
  onClickCopy,
  onClickUndo,
  onClickApplyAll,
  isUndoBtnDisabled,
  isCropBtnDisabled,
}: SessionCropTaskBarProps) {
  const { t } = useTranslation()

  const buttonMenu = [
    {
      label: t("button.applyAll"),
      value: CropOption.applyAll,
    },
    {
      label: t("button.copy"),
      value: CropOption.copy,
    },
  ]

  const onClickList = (e: Event, value: CropOption) => {
    switch (value) {
      case CropOption.copy:
        onClickCopy?.()
        break
      case CropOption.applyAll:
        onClickApplyAll?.()
        break
    }
  }

  return (
    <div className="SessionCropTaskBarCont">
      <BasicButton size={"sm"} type={"ghost"} disabled={isUndoBtnDisabled} onClick={onClickUndo}>
        <Icon type={"arrow-go-back-fill"} size={16} />
        <p>{t("button.undo")}</p>
      </BasicButton>
      <div className="button-cont">
        {isSelectingCopyItem ? (
          <>
            <BasicButton size={"sm"} type={"primary-contained"} onClick={onClickCrop}>
              <span>{t("button.crop")}</span>
            </BasicButton>
            <BasicButton
              className="cancel-copy-btn"
              size={"sm"}
              type={"default-outlined"}
              onClick={onClickCancel}>
              {t("button.cancel")}
            </BasicButton>
          </>
        ) : (
          <SplitButton
            className="crop-split-btn"
            type={"primary-contained"}
            disabled={isCropBtnDisabled}
            buttonText={
              <span className="crop-btn-text">
                <Icon type={"scissor-cut-fill"} size={16} />
                {t("button.crop")}
              </span>
            }
            list={buttonMenu}
            onClickButton={onClickCrop || (() => {})}
            onClickList={onClickList}
            splitButtonClassName="SessionCropTaskBarSplitButton"
          />
        )}
      </div>
    </div>
  )
}
